import { get } from '../utils/api';
import { DepartmentResponse, updateTeamsPayload } from '../features/jobApplication/JobApplicationTypes';
import { put } from '../utils/api';
import { formatUrl } from '../utils/urlFormatter';



const update_billing_details = '/{0}/{1}/billing.update';
const fetch_billing_details = '/{0}/billing.detail';
const fetch_plan = '/base/plan'
// const create_billing = '/{0}/applicationQuestion.createUpdate';

const credentialsConfig = {
  withCredentials: true,
}


export const updateBilling = async (baseId: number, id: number, data: updateTeamsPayload): Promise<DepartmentResponse> => {
  const update_billing_data = formatUrl(update_billing_details, [baseId, id]);
  return put<DepartmentResponse>(update_billing_data, data, credentialsConfig);
};


export const fetchBillingDetails = async (baseId: number): Promise<DepartmentResponse> => {
  const fetch_billing_data = formatUrl(fetch_billing_details, [baseId]);
  return get<DepartmentResponse>(fetch_billing_data, credentialsConfig);
};

// export const createBillingData = async (data: createTeamsPayload[], userId: number): Promise<DepartmentResponse> => {
//     const base_create_billing = formatUrl(create_billing, [userId]);
//     return post<DepartmentResponse>(base_create_billing, data , credentialsConfig);
// };

export const fetchPlanDetails = async (id: number, currency: string): Promise<DepartmentResponse> => {
  const fetch_plan_data = `${fetch_plan}?id=${id}&currency=${currency}`;
  return get<DepartmentResponse>(fetch_plan_data, credentialsConfig);
};

